import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    const isAuth = this.authService.isAuth();

    if (!isAuth) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
